"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalHeader = void 0;
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("@mui/material/Box"));
var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
var _AccountMenu = require("../AccountMenu");
var _ModalTitle = require("./ModalTitle");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ModalHeader = exports.ModalHeader = function ModalHeader(_ref) {
  var title = _ref.title,
    transitioning = _ref.transitioning,
    stepName = _ref.stepName,
    closeDialog = _ref.closeDialog,
    profileDialog = _ref.profileDialog,
    _logout = _ref.logout,
    steps = _ref.steps,
    goToStep = _ref.goToStep;
  if (transitioning) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    sx: {
      display: "flex",
      flexDirection: "row",
      flexGrow: 4,
      alignItems: "center"
    }
  }, /*#__PURE__*/_react.default.createElement(_ModalTitle.ModalTitle, {
    title: title,
    stepName: stepName,
    steps: steps,
    goToStep: goToStep
  }), stepName === "compose" && /*#__PURE__*/_react.default.createElement(_Box.default, {
    sx: {
      marginLeft: "auto"
    }
  }, stepName === "compose" && /*#__PURE__*/_react.default.createElement(_AccountMenu.AccountMenu, {
    logout: function logout() {
      return _logout();
    },
    profile: profileDialog
  }), false && stepName !== "compose" && /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    edge: "start",
    color: "inherit",
    onClick: closeDialog,
    "aria-label": "close"
  }, /*#__PURE__*/_react.default.createElement(_Close.default, null))));
};